(function($){
    "use strict";

    const $identity = $('#f_identity', contextEl);
    const $password = $('#f_password', contextEl);

    const $btnLogin = $('#btn_submitLogin', contextEl);

    $(function () {

        const submitLogin = (e) => {
            let $this = $(e.currentTarget);
            if (!$this || ($this && $this.length < 1)) {
                return;
            }
            let formData = $this.closest('form').serializeArray();
            let targetUrl = URL_SUBMITLOGIN;

            $(e.currentTarget).on('action:success', async (e, data) => {

                const $btn = $(e.currentTarget);
                $btn.prop('disabled', 'disabled');

                toastr.success(data.message);
                // Must change the page by looping
                for (let i = 0; i < 12; i++) {
                    setTimeout(() => {
                        if (data.redirect_path) {
                            location.href = data.redirect_path;
                        } else {
                            window.location.reload(true);
                        }
                    }, (i + 1) * 1000);
                }


            })
            $(e.currentTarget).on('action:errorT', async (e, data) => {

                if (!data || !data.responseJSON) {
                    return;
                }


                data = data.responseJSON
                if (data.errors) {
                    if (data.errors.username && data.errors.username[0]) {
                        $identity.parent().append('<div class="fv-plugins-message-container invalid-feedback">' + data.errors.username[0] + '</div>');
                    }
                    if (data.errors.password && data.errors.password[0]) {
                        $password.parent().append('<div class="fv-plugins-message-container invalid-feedback">' + data.errors.password[0] + '</div>');
                    }
                }
            })

            // Begin trigger
            App.buttonAction({
                e: e,
                url: targetUrl,
                formData: formData,
                swal: null,
                // callbackLoading: customLoadingSwal,
            }).then(resp => {

                // console.log(resp);

            });
            return;
        }


        $btnLogin.removeAttr('disabled');
        $btnLogin.on('click', function (e) {
            e.preventDefault();
            
            submitLogin(e);
        })
    });

})(window.jQuery)